export const permissions = [
  'notifications.settings.view',
  'notifications.settings.manage',
  'mailbox.inbox.view',
  'mailbox.inbox.manage',
  'settings.mailbox.view',
  'settings.mailbox.manage',
  'settings.mailbox.test',
  'dashboard.view',
  'inbox.view',
  'inbox.reply',
  'inbox.assign',
  'inbox.resolve',
  'inbox.escalate',
  'livechat.view',
  'feedback.livechat.view',
  'feedback.recovery.view',
  'feedback.ea_survey.view',
  'livechat.actions',
  'livechat.administrator',
  'whatsapp.view',
  'whatsapp.actions',
  'whatsapp.administrator',
  'whatsapp.settings.view',
  'whatsapp.settings.manage',
  'whatsapp.audit.view',
  'tickets.view',
  'tickets.create',
  'tickets.edit',
  'tickets.assign',
  'tickets.resolve',
  'tickets.escalate',
  'calls.view',
  'calls.settings.view',
  'calls.settings.manage',
  'calls.create',
  'calls.play_recording',
  'calls.view_transcript',
  'calls.link_ticket',
  'knowledge.view',
  'knowledge.create',
  'knowledge.edit',
  'knowledge.review',
  'knowledge.approve',
  'knowledge.publish',
  'knowledge.delete',
  'knowledge.reindex',
  'knowledge.insert',
  'knowledge.manage_taxonomy',
  'knowledge.manage_languages',
  'knowledge.manage_feedback',
  'knowledge.manage_settings',
  'knowledge.gaps.view',
  'knowledge.gaps.manage',
  'knowledge.connectors.view',
  'knowledge.connectors.analytics.view',
  'knowledge.connectors.manage',
  'knowledge.connectors.credentials.manage',
  'escalations.view',
  'escalations.create',
  'escalations.accept',
  'escalations.resolve',
  'escalations.manage',
  'reports.view',
  'reports.export',
  'users.view',
  'users.manage',
  'roles.view',
  'roles.manage',
  'teams.view',
  'teams.manage',
  'entities.view',
  'entities.manage',
  'channels.view',
  'channels.manage',
  'sla.view',
  'sla.manage',
  'settings.view',
  'settings.manage',
  'customers.view_sensitive',
] as const;

export type Permission = (typeof permissions)[number];

const agent: Permission[] = [
  'dashboard.view',
  'inbox.view',
  'inbox.reply',
  'livechat.view',
  'livechat.actions',
  'whatsapp.view',
  'whatsapp.actions',
  'tickets.view',
  'tickets.create',
  'tickets.edit',
  'calls.view',
  'calls.create',
  'knowledge.view',
  'knowledge.insert',
  'escalations.view',
  'escalations.create',
  'reports.view',
];
const senior: Permission[] = [
  ...agent,
  'inbox.assign',
  'inbox.resolve',
  'inbox.escalate',
  'livechat.view',
  'livechat.actions',
  'whatsapp.view',
  'whatsapp.actions',
  'tickets.assign',
  'tickets.resolve',
  'tickets.escalate',
  'knowledge.create',
  'knowledge.edit',
  'escalations.accept',
  'escalations.resolve',
  'customers.view_sensitive',
];
const supervisor: Permission[] = [
  ...permissions.filter((permission) => !permission.endsWith('.manage')),
  'reports.export',
];
const knowledgeManager: Permission[] = [
  'dashboard.view',
  'inbox.view',
  'livechat.view',
  'livechat.actions',
  'whatsapp.view',
  'whatsapp.actions',
  'tickets.view',
  'calls.view',
  'knowledge.view',
  'knowledge.create',
  'knowledge.edit',
  'knowledge.review',
  'knowledge.approve',
  'knowledge.publish',
  'knowledge.delete',
  'knowledge.reindex',
  'knowledge.insert',
  'knowledge.manage_taxonomy',
  'knowledge.manage_languages',
  'knowledge.manage_feedback',
  'knowledge.manage_settings',
  'knowledge.gaps.view',
  'knowledge.gaps.manage',
  'knowledge.connectors.view',
  'knowledge.connectors.analytics.view',
  'knowledge.connectors.manage',
  'knowledge.connectors.credentials.manage',
  'reports.view',
  'reports.export',
];
const readOnlyQa: Permission[] = permissions.filter((permission) => permission.endsWith('.view'));

export const rolePermissions = {
  agent,
  senior,
  supervisor,
  knowledgeManager,
  administrator: [...permissions],
  readOnlyQa,
} satisfies Record<string, Permission[]>;

export type RoleKey = keyof typeof rolePermissions;

export function hasPermission(granted: readonly Permission[], required?: Permission): boolean {
  return required === undefined || granted.includes(required);
}
